"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var loginBg_jpeg_1 = __importDefault(require("@/assets/img/loginBg.jpeg"));
var logo_png_1 = __importDefault(require("@/assets/img/logo.png"));
var _withScopeId = function (n) { return ((0, vue_2.pushScopeId)("data-v-465010d0"), n = n(), (0, vue_2.popScopeId)(), n); };
var _hoisted_1 = { class: "login-layout" };
var _hoisted_2 = { className: "waves" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("h3", { class: "system-title" }, [
    /*#__PURE__*/ (0, vue_2.createTextVNode)(" 星域平台学习系统 "),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("img", {
        src: logo_png_1.default,
        alt: "",
        class: "logo"
    })
], -1); });
var _hoisted_4 = { style: { "text-align": "right", "width": "100%" } };
var _hoisted_5 = ["src"];
var _hoisted_6 = { class: "dialog-footer" };
var _hoisted_7 = { class: "dialog-footer" };
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("p", { class: "filings-number" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("a", { href: "https://beian.miit.gov.cn" }, "网站备案/许可证编号：黔ICP备2023014986号")
], -1); });
var vue_3 = require("vue");
var element_plus_1 = require("element-plus");
var vue_router_1 = require("vue-router");
var jsencrypt_1 = __importDefault(require("jsencrypt"));
var users_1 = require("@/apis/users");
var index_1 = require("@/store/index");
var core_1 = require("@vueuse/core");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Login',
    setup: function (__props) {
        var _this = this;
        var counterStore = (0, index_1.useMainStore)();
        var isDark = (0, core_1.useDark)();
        var initBlackCanvas = function () {
            var canvas = document.getElementById('canvas'), ctx = canvas.getContext('2d'), w = canvas.width = window.innerWidth, h = canvas.height = window.innerHeight, hue = 217, stars = [], count = 0, maxStars = 1400;
            var canvas2 = document.createElement('canvas');
            var ctx2 = canvas2.getContext('2d');
            canvas2.width = 100;
            canvas2.height = 100;
            var half = canvas2.width / 2, gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half);
            gradient2.addColorStop(0.025, '#fff');
            gradient2.addColorStop(0.1, 'hsl(' + hue + ', 61%, 33%)');
            gradient2.addColorStop(0.25, 'hsl(' + hue + ', 64%, 6%)');
            gradient2.addColorStop(1, 'transparent');
            ctx2.fillStyle = gradient2;
            ctx2.beginPath();
            ctx2.arc(half, half, half, 0, Math.PI * 2);
            ctx2.fill();
            // End cache
            function random(min, max) {
                if (arguments.length < 2) {
                    max = min;
                    min = 0;
                }
                if (min > max) {
                    var hold = max;
                    max = min;
                    min = hold;
                }
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
            var Star = /** @class */ (function () {
                function Star() {
                    this.orbitRadius = random(0, w / 2 - 50);
                    this.radius = random(100, this.orbitRadius) / 10;
                    this.orbitX = w / 2;
                    this.orbitY = h / 2;
                    this.timePassed = random(0, maxStars);
                    this.speed = random(0, this.orbitRadius) / 900000;
                    this.alpha = random(2, 10) / 10;
                    count++;
                    stars[count] = this;
                }
                Star.prototype.draw = function () { };
                return Star;
            }());
            Star.prototype.draw = function () {
                var x = Math.sin(this.timePassed + 1) * this.orbitRadius + this.orbitX, y = Math.cos(this.timePassed) * this.orbitRadius / 2 + this.orbitY, twinkle = random(0, 10);
                if (twinkle === 1 && this.alpha > 0) {
                    this.alpha -= 0.05;
                }
                else if (twinkle === 2 && this.alpha < 1) {
                    this.alpha += 0.05;
                }
                ctx.globalAlpha = this.alpha;
                ctx.drawImage(canvas2, x - this.radius / 2, y - this.radius / 2, this.radius, this.radius);
                this.timePassed += this.speed;
            };
            for (var i = 0; i < maxStars; i++) {
                new Star();
            }
            function animation() {
                ctx.globalCompositeOperation = 'source-over';
                ctx.globalAlpha = 0.8;
                // ctx.fillStyle = 'hsla(' + hue + ', 64%, 6%, 1)'; 
                ctx.fillRect(0, 0, w, h);
                ctx.globalCompositeOperation = 'lighter';
                var l = stars.length;
                for (var i = 1; i < l; i++) {
                    stars[i].draw();
                }
                ;
                window.requestAnimationFrame(animation);
            }
            animation();
        };
        var initWhiteCanvas = function () {
            var ShaderProgram = /** @class */ (function () {
                function ShaderProgram(holder, options) {
                    var _this = this;
                    if (options === void 0) { options = {}; }
                    options = Object.assign({
                        antialias: false,
                        depthTest: false,
                        mousemove: false,
                        autosize: true,
                        side: 'front',
                        vertex: "\nprecision highp float;\n\nattribute vec4 a_position;\nattribute vec4 a_color;\n\nuniform float u_time;\nuniform vec2 u_resolution;\nuniform vec2 u_mousemove;\nuniform mat4 u_projection;\n\nvarying vec4 v_color;\n\nvoid main() {\n\ngl_Position = u_projection * a_position;\ngl_PointSize = (10.0 / gl_Position.w) * 100.0;\n\nv_color = a_color;\n\n}",
                        fragment: "\nprecision highp float;\n\nuniform sampler2D u_texture;\nuniform int u_hasTexture;\n\nvarying vec4 v_color;\n\nvoid main() {\n\nif ( u_hasTexture == 1 ) {\n\n  gl_FragColor = v_color * texture2D(u_texture, gl_PointCoord);\n\n} else {\n\n  gl_FragColor = v_color;\n\n}\n\n}",
                        uniforms: {},
                        buffers: {},
                        camera: {},
                        texture: null,
                        onUpdate: (function () { }),
                        onResize: (function () { }),
                    }, options);
                    var uniforms = Object.assign({
                        time: {
                            type: 'float',
                            value: 0
                        },
                        hasTexture: {
                            type: 'int',
                            value: 0
                        },
                        resolution: {
                            type: 'vec2',
                            value: [0, 0]
                        },
                        mousemove: {
                            type: 'vec2',
                            value: [0, 0]
                        },
                        projection: {
                            type: 'mat4',
                            value: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
                        },
                    }, options.uniforms);
                    var buffers = Object.assign({
                        position: {
                            size: 3,
                            data: []
                        },
                        color: {
                            size: 4,
                            data: []
                        },
                    }, options.buffers);
                    var camera = Object.assign({
                        fov: 60,
                        near: 1,
                        far: 10000,
                        aspect: 1,
                        z: 100,
                        perspective: true,
                    }, options.camera);
                    var canvas = document.createElement('canvas');
                    var gl = canvas.getContext('webgl', {
                        antialias: options.antialias
                    });
                    if (!gl)
                        return false;
                    this.count = 0;
                    this.gl = gl;
                    this.canvas = canvas;
                    this.camera = camera;
                    this.holder = holder;
                    this.onUpdate = options.onUpdate;
                    this.onResize = options.onResize;
                    this.data = {};
                    holder.appendChild(canvas);
                    this.createProgram(options.vertex, options.fragment);
                    this.createBuffers(buffers);
                    this.createUniforms(uniforms);
                    this.updateBuffers();
                    this.updateUniforms();
                    this.createTexture(options.texture);
                    gl.enable(gl.BLEND);
                    gl.enable(gl.CULL_FACE);
                    gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                    gl[options.depthTest ? 'enable' : 'disable'](gl.DEPTH_TEST);
                    if (options.autosize)
                        window.addEventListener('resize', function (e) { return _this.resize(e); }, false);
                    if (options.mousemove)
                        window.addEventListener('mousemove', function (e) { return _this.mousemove(e); }, false);
                    this.resize();
                    this.update = this.update.bind(this);
                    this.time = {
                        start: performance.now(),
                        old: performance.now()
                    };
                    this.update();
                }
                ShaderProgram.prototype.mousemove = function (e) {
                    var x = e.pageX / this.width * 2 - 1;
                    var y = e.pageY / this.height * 2 - 1;
                    this.uniforms.mousemove = [x, y];
                };
                ShaderProgram.prototype.resize = function (e) {
                    var holder = this.holder;
                    var canvas = this.canvas;
                    var gl = this.gl;
                    var width = this.width = holder.offsetWidth;
                    var height = this.height = holder.offsetHeight;
                    var aspect = this.aspect = width / height;
                    var dpi = this.dpi = devicePixelRatio;
                    canvas.width = width * dpi;
                    canvas.height = height * dpi;
                    canvas.style.width = width + 'px';
                    canvas.style.height = height + 'px';
                    gl.viewport(0, 0, width * dpi, height * dpi);
                    gl.clearColor(0, 0, 0, 0);
                    this.uniforms.resolution = [width, height];
                    this.uniforms.projection = this.setProjection(aspect);
                    this.onResize(width, height, dpi);
                };
                ShaderProgram.prototype.setProjection = function (aspect) {
                    var camera = this.camera;
                    if (camera.perspective) {
                        camera.aspect = aspect;
                        var fovRad = camera.fov * (Math.PI / 180);
                        var f = Math.tan(Math.PI * 0.5 - 0.5 * fovRad);
                        var rangeInv = 1.0 / (camera.near - camera.far);
                        var matrix = [
                            f / camera.aspect, 0, 0, 0,
                            0, f, 0, 0,
                            0, 0, (camera.near + camera.far) * rangeInv, -1,
                            0, 0, camera.near * camera.far * rangeInv * 2, 0
                        ];
                        matrix[14] += camera.z;
                        matrix[15] += camera.z;
                        return matrix;
                    }
                    else {
                        return [
                            2 / this.width, 0, 0, 0,
                            0, -2 / this.height, 0, 0,
                            0, 0, 1, 0, -1, 1, 0, 1,
                        ];
                    }
                };
                ShaderProgram.prototype.createShader = function (type, source) {
                    var gl = this.gl;
                    var shader = gl.createShader(type);
                    gl.shaderSource(shader, source);
                    gl.compileShader(shader);
                    if (gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
                        return shader;
                    }
                    else {
                        console.log(gl.getShaderInfoLog(shader));
                        gl.deleteShader(shader);
                    }
                };
                ShaderProgram.prototype.createProgram = function (vertex, fragment) {
                    var gl = this.gl;
                    var vertexShader = this.createShader(gl.VERTEX_SHADER, vertex);
                    var fragmentShader = this.createShader(gl.FRAGMENT_SHADER, fragment);
                    var program = gl.createProgram();
                    gl.attachShader(program, vertexShader);
                    gl.attachShader(program, fragmentShader);
                    gl.linkProgram(program);
                    if (gl.getProgramParameter(program, gl.LINK_STATUS)) {
                        gl.useProgram(program);
                        this.program = program;
                    }
                    else {
                        console.log(gl.getProgramInfoLog(program));
                        gl.deleteProgram(program);
                    }
                };
                ShaderProgram.prototype.createUniforms = function (data) {
                    var _this = this;
                    var gl = this.gl;
                    var uniforms = this.data.uniforms = data;
                    var values = this.uniforms = {};
                    Object.keys(uniforms).forEach(function (name) {
                        var uniform = uniforms[name];
                        uniform.location = gl.getUniformLocation(_this.program, 'u_' + name);
                        Object.defineProperty(values, name, {
                            set: function (value) {
                                uniforms[name].value = value;
                                _this.setUniform(name, value);
                            },
                            get: function () { return uniforms[name].value; }
                        });
                    });
                };
                ShaderProgram.prototype.setUniform = function (name, value) {
                    var gl = this.gl;
                    var uniform = this.data.uniforms[name];
                    uniform.value = value;
                    switch (uniform.type) {
                        case 'int': {
                            gl.uniform1i(uniform.location, value);
                            break;
                        }
                        case 'float': {
                            gl.uniform1f(uniform.location, value);
                            break;
                        }
                        case 'vec2': {
                            gl.uniform2f.apply(gl, __spreadArray([uniform.location], value, false));
                            break;
                        }
                        case 'vec3': {
                            gl.uniform3f.apply(gl, __spreadArray([uniform.location], value, false));
                            break;
                        }
                        case 'vec4': {
                            gl.uniform4f.apply(gl, __spreadArray([uniform.location], value, false));
                            break;
                        }
                        case 'mat2': {
                            gl.uniformMatrix2fv(uniform.location, false, value);
                            break;
                        }
                        case 'mat3': {
                            gl.uniformMatrix3fv(uniform.location, false, value);
                            break;
                        }
                        case 'mat4': {
                            gl.uniformMatrix4fv(uniform.location, false, value);
                            break;
                        }
                    }
                    // ivec2       : uniform2i,
                    // ivec3       : uniform3i,
                    // ivec4       : uniform4i,
                    // sampler2D   : uniform1i,
                    // samplerCube : uniform1i,
                    // bool        : uniform1i,
                    // bvec2       : uniform2i,
                    // bvec3       : uniform3i,
                    // bvec4       : uniform4i,
                };
                ShaderProgram.prototype.updateUniforms = function () {
                    var _this = this;
                    var gl = this.gl;
                    var uniforms = this.data.uniforms;
                    Object.keys(uniforms).forEach(function (name) {
                        var uniform = uniforms[name];
                        _this.uniforms[name] = uniform.value;
                    });
                };
                ShaderProgram.prototype.createBuffers = function (data) {
                    var _this = this;
                    var gl = this.gl;
                    var buffers = this.data.buffers = data;
                    var values = this.buffers = {};
                    Object.keys(buffers).forEach(function (name) {
                        var buffer = buffers[name];
                        buffer.buffer = _this.createBuffer('a_' + name, buffer.size);
                        Object.defineProperty(values, name, {
                            set: function (data) {
                                buffers[name].data = data;
                                _this.setBuffer(name, data);
                                if (name == 'position')
                                    _this.count = buffers.position.data.length / 3;
                            },
                            get: function () { return buffers[name].data; }
                        });
                    });
                };
                ShaderProgram.prototype.createBuffer = function (name, size) {
                    var gl = this.gl;
                    var program = this.program;
                    var index = gl.getAttribLocation(program, name);
                    var buffer = gl.createBuffer();
                    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                    gl.enableVertexAttribArray(index);
                    gl.vertexAttribPointer(index, size, gl.FLOAT, false, 0, 0);
                    return buffer;
                };
                ShaderProgram.prototype.setBuffer = function (name, data) {
                    var gl = this.gl;
                    var buffers = this.data.buffers;
                    if (name == null && !gl.bindBuffer(gl.ARRAY_BUFFER, null))
                        return;
                    gl.bindBuffer(gl.ARRAY_BUFFER, buffers[name].buffer);
                    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(data), gl.STATIC_DRAW);
                };
                ShaderProgram.prototype.updateBuffers = function () {
                    var gl = this.gl;
                    var buffers = this.buffers;
                    Object.keys(buffers).forEach(function (name) {
                        return buffers[name] = buffer.data;
                    });
                    this.setBuffer(null);
                };
                ShaderProgram.prototype.createTexture = function (src) {
                    var gl = this.gl;
                    var texture = gl.createTexture();
                    gl.bindTexture(gl.TEXTURE_2D, texture);
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 0]));
                    this.texture = texture;
                    if (src) {
                        this.uniforms.hasTexture = 1;
                        this.loadTexture(src);
                    }
                };
                ShaderProgram.prototype.loadTexture = function (src) {
                    var gl = this.gl;
                    var texture = this.texture;
                    var textureImage = new Image();
                    textureImage.onload = function () {
                        gl.bindTexture(gl.TEXTURE_2D, texture);
                        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureImage);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                        // gl.generateMipmap( gl.TEXTURE_2D )
                    };
                    textureImage.src = src;
                };
                ShaderProgram.prototype.update = function () {
                    var gl = this.gl;
                    var now = performance.now();
                    var elapsed = (now - this.time.start) / 5000;
                    var delta = now - this.time.old;
                    this.time.old = now;
                    this.uniforms.time = elapsed;
                    if (this.count > 0) {
                        // gl.clear(gl.COLORBUFFERBIT)
                        gl.drawArrays(gl.POINTS, 0, this.count);
                    }
                    this.onUpdate(delta);
                    requestAnimationFrame(this.update);
                };
                return ShaderProgram;
            }());
            var pointSize = 2.5;
            var waves = new ShaderProgram(document.querySelector('.waves'), {
                texture: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAb1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8v0wLRAAAAJHRSTlMAC/goGvDhmwcExrVjWzrm29TRqqSKenRXVklANSIUE8mRkGpv+HOfAAABCElEQVQ4y4VT13LDMAwLrUHteO+R9f/fWMfO6dLaPeKVEECRxOULWsEGpS9nULDwia2Y+ALqUNbAWeg775zv+sA4/FFRMxt8U2FZFCVWjR/YrH4/H9sarclSKdPMWKzb8VsEeHB3m0shkhVCyNzeXeAQ9Xl4opEieX2QCGnwGbj6GMyjw9t1K0fK9YZunPXeAGsfJtYjwzxaBnozGGorYz0ypK2HzQSYx1y8DgSRo2ewOiyh2QWOEk1Y9OrQV0a8TiBM1a8eMHWYnRMy7CZ4t1CmyRkhSUvP3gRXyHOCLBxNoC3IJv//ZrJ/kxxUHPUB+6jJZZHrpg6GOjnqaOmzp4NDR48OLxn/H27SRQ08S0ZJAAAAAElFTkSuQmCC',
                uniforms: {
                    size: {
                        type: 'float',
                        value: pointSize
                    },
                    field: {
                        type: 'vec3',
                        value: [0, 0, 0]
                    },
                    speed: {
                        type: 'float',
                        value: 5
                    },
                },
                vertex: "\n#define M_PI 3.1415926535897932384626433832795\n\nprecision highp float;\n\nattribute vec4 a_position;\nattribute vec4 a_color;\n\nuniform float u_time;\nuniform float u_size;\nuniform float u_speed;\nuniform vec3 u_field;\nuniform mat4 u_projection;\n\nvarying vec4 v_color;\n\nvoid main() {\n\nvec3 pos = a_position.xyz;\n\npos.y += (\ncos(pos.x / u_field.x * M_PI * 8.0 + u_time * u_speed) +\nsin(pos.z / u_field.z * M_PI * 8.0 + u_time * u_speed)\n) * u_field.y;\n\ngl_Position = u_projection * vec4( pos.xyz, a_position.w );\ngl_PointSize = ( u_size / gl_Position.w ) * 100.0;\n\nv_color = a_color;\n\n}",
                fragment: "\nprecision highp float;\n\nuniform sampler2D u_texture;\n\nvarying vec4 v_color;\n\nvoid main() {\n\ngl_FragColor = v_color * texture2D(u_texture, gl_PointCoord);\n\n}",
                onResize: function (w, h, dpi) {
                    var position = [], color = [];
                    var width = 400 * (w / h);
                    var depth = 400;
                    var height = 3;
                    var distance = 5;
                    for (var x = 0; x < width; x += distance) {
                        for (var z = 0; z < depth; z += distance) {
                            position.push(-width / 2 + x, -30, -depth / 2 + z);
                            color.push(0, 1 - (x / width) * 1, 0.5 + x / width * 0.5, z / depth);
                        }
                    }
                    this.uniforms.field = [width, height, depth];
                    this.buffers.position = position;
                    this.buffers.color = color;
                    this.uniforms.size = (h / 400) * pointSize * dpi;
                },
            });
        };
        var onChange = function () {
            counterStore.changeTheme();
        };
        var mainStore = (0, index_1.useMainStore)();
        var isShowDialog = (0, vue_3.ref)(false);
        var userForm = (0, vue_3.reactive)({
            user_account: "",
            user_name: "",
            password: "",
            tel: "",
            email: "",
            age: null,
            sex: "",
        });
        var checkAccount = function (rule, value, callback) {
            if (value.length < 5) {
                return callback(new Error('注册账号长度不得低于5位'));
            }
            (0, users_1.checkUserAccount)({ user_account: userForm.user_account }).then(function (res) {
                try {
                    if (res.code == 200) {
                        element_plus_1.ElMessage.success(res.message);
                        callback();
                    }
                    else {
                        callback(new Error("注册信息已存在，请重新输入"));
                    }
                }
                catch (_a) {
                    callback(new Error("注册信息已存在，请重新输入"));
                }
            });
        };
        var rules = (0, vue_3.reactive)({
            user_account: [
                { required: true, validator: checkAccount, trigger: "blur", }
            ],
            user_name: [{ required: true, message: "昵称不能为空", trigger: "blur" }],
            password: [{
                    required: true, message: "密码不能为空", trigger: "blur"
                }],
            email: [
                { pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: '请正确输入邮箱', trigger: 'change' },
                { required: true, message: "不能为空", trigger: "blur" }
            ],
            tel: [
                { pattern: /^(?:(?:\+|00)86)?1\d{10}$/, message: '请正确输入电话号码', trigger: 'change' },
                { required: true, message: "不能为空", trigger: "blur" }
            ],
            sex: [{
                    required: true, message: "不能为空", trigger: "blur"
                }],
            age: [{
                    required: true, message: "不能为空", trigger: "blur"
                }],
        });
        var ruleFormRef = (0, vue_3.ref)();
        var encryptor_psd = function (password) {
            var key = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAml4xtv7nCX60taROCzaZ\n            GeY7AUhvMSg55ZTnv167csMy9QSFATByLbGnHaRejtQnOKUq9Ri94X5jHYCFCqYy\n            ImpUydpv1PWimUKFaVmDxK2xIAX1UTwpIT8C2LdM98RPvD3z4soH0n2tYJkR8Q9G\n            Gtw89jTyVkUQRnZr/RBgosOwYcpQnh5k1X0ObpyqowdamLf7nKxmndk9krw1f5zJ\n            YOqhlBVijqxylxOmlR0HHQKtrEgcB66uSMblI4Zc4fxQlPUXiOIAGIvLT95Kl2M1\n            k9rvMUePo18gKbr1N0wHYV2UKo7Kj9ZOJ0Ae1AfIVYPbrrLLLlV0JWlr+YgDPnij\n            WwIDAQAB";
            var encryptor = new jsencrypt_1.default();
            encryptor.setPublicKey(key);
            return encryptor.encrypt(password);
        };
        var onFinish = function (formEl) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!formEl)
                            return [2 /*return*/];
                        return [4 /*yield*/, formEl.validate(function (valid, fields) {
                                if (valid) {
                                    userForm.password = encryptor_psd(userForm.password);
                                    (0, users_1.register)(userForm).then(function (res) {
                                        if (res.code == 200) {
                                            element_plus_1.ElMessage.success("注册成功");
                                            isShowDialog.value = false;
                                        }
                                    });
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var verificationCode = (0, vue_3.ref)('');
        var router = (0, vue_router_1.useRouter)();
        var loginForm = (0, vue_3.reactive)({
            user_account: "",
            password: "",
            verification: "",
            code: "",
        });
        var fetchVerificationCode = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loginForm.code = '';
                        return [4 /*yield*/, (0, users_1.getVerificationCode)()];
                    case 1:
                        data = (_a.sent()).data;
                        verificationCode.value = 'data:image/png;base64,' + data.img;
                        loginForm.code = data.code;
                        return [2 /*return*/];
                }
            });
        }); };
        (0, vue_3.onMounted)(function () {
            initBlackCanvas();
            initWhiteCanvas();
        });
        fetchVerificationCode();
        // 获取用户代理字符串
        var userLogin = function () {
            if (!loginForm.user_account) {
                element_plus_1.ElMessage.warning("请输入用户名");
                return;
            }
            if (loginForm.verification.length !== 4) {
                element_plus_1.ElMessage.warning("请正确输入验证码");
                return;
            }
            if (!loginForm.password) {
                element_plus_1.ElMessage.warning("请输入密码");
                return;
            }
            var formData = Object.assign({}, loginForm);
            formData.password = encryptor_psd(loginForm.password);
            (0, users_1.login)(formData).then(function (res) {
                if (res.code == 200 && res.data) {
                    localStorage.setItem("token", res.data.token);
                    localStorage.setItem("user_data", JSON.stringify(res.data.user_data));
                    element_plus_1.ElMessage.success("登录成功");
                    element_plus_1.ElNotification.closeAll();
                    router.push({ path: "/home" });
                }
                else {
                    fetchVerificationCode();
                    loginForm.verification = '';
                }
            }).catch(function () {
                fetchVerificationCode();
                loginForm.verification = '';
            });
        };
        var isShowPswDialog = (0, vue_3.ref)(false);
        var ruleFormPswRef = (0, vue_3.ref)();
        var userPswForm = (0, vue_3.reactive)({
            user_account: "",
            password: "",
            tel: "",
            email: "",
        });
        var pswRules = (0, vue_3.reactive)({
            user_account: [
                { required: true, message: "账户名不能为空", trigger: "blur", }
            ],
            password: [{
                    required: true, message: "密码不能为空", trigger: "blur"
                }],
            email: [
                { pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: '请正确输入邮箱', trigger: 'change' },
                { required: true, message: "不能为空", trigger: "blur" }
            ],
            tel: [
                { pattern: /^(?:(?:\+|00)86)?1\d{10}$/, message: '请正确输入电话号码', trigger: 'change' },
                { required: true, message: "不能为空", trigger: "blur" }
            ],
        });
        var onFinishPsw = function (formEl) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!formEl)
                            return [2 /*return*/];
                        return [4 /*yield*/, formEl.validate(function (valid, fields) {
                                if (valid) {
                                    userPswForm.password = encryptor_psd(userPswForm.password);
                                    (0, users_1.resetPassword)(userPswForm).then(function (res) {
                                        if (res.code == 200) {
                                            element_plus_1.ElMessage.success("密码重置成功");
                                            isShowPswDialog.value = false;
                                        }
                                    }).finally(function () {
                                        userPswForm.password = '';
                                    });
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        return function (_ctx, _cache) {
            var _component_el_switch = (0, vue_2.resolveComponent)("el-switch");
            var _component_el_input = (0, vue_2.resolveComponent)("el-input");
            var _component_el_form_item = (0, vue_2.resolveComponent)("el-form-item");
            var _component_el_button = (0, vue_2.resolveComponent)("el-button");
            var _component_el_form = (0, vue_2.resolveComponent)("el-form");
            var _component_el_option = (0, vue_2.resolveComponent)("el-option");
            var _component_el_select = (0, vue_2.resolveComponent)("el-select");
            var _component_el_dialog = (0, vue_2.resolveComponent)("el-dialog");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", null, [
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("canvas", {
                        id: "canvas",
                        class: (0, vue_2.normalizeClass)({ bg2: (0, vue_2.unref)(isDark) })
                    }, null, 2), [
                        [vue_2.vShow, (0, vue_2.unref)(isDark)]
                    ]),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_2, null, 512), [
                        [vue_2.vShow, !(0, vue_2.unref)(isDark)]
                    ]),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("img", {
                        id: "bg-img",
                        class: (0, vue_2.normalizeClass)({ bg1: !(0, vue_2.unref)(isDark) }),
                        src: loginBg_jpeg_1.default,
                        alt: ""
                    }, null, 2), [
                        [vue_2.vShow, !(0, vue_2.unref)(isDark)]
                    ]),
                    (0, vue_2.createVNode)(_component_el_switch, {
                        class: "right-switch",
                        size: "large",
                        onChange: onChange,
                        style: { "--el-switch-on-color": "#2c2c2c", "--el-switch-off-color": "#f2f2f2" },
                        modelValue: (0, vue_2.unref)(isDark),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((0, vue_2.isRef)(isDark) ? (isDark).value = $event : null); }),
                        "inline-prompt": "",
                        "active-action-icon": "Moon",
                        "inactive-action-icon": "Sunny"
                    }, null, 8, ["modelValue"]),
                    (0, vue_2.createElementVNode)("div", {
                        class: "form-layout",
                        style: (0, vue_2.normalizeStyle)((0, vue_2.unref)(mainStore).isDark ? '' : 'background: #fff;')
                    }, [
                        _hoisted_3,
                        (0, vue_2.createVNode)(_component_el_form, {
                            "label-position": 'top',
                            model: loginForm
                        }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "登录账号：" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            "prefix-icon": "User",
                                            placeholder: "请输入登录账号",
                                            onKeydown: (0, vue_2.withKeys)(userLogin, ["enter"]),
                                            size: "large",
                                            modelValue: loginForm.user_account,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((loginForm.user_account) = $event); })
                                        }, null, 8, ["onKeydown", "modelValue"])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, { label: "登录密码：" }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            "prefix-icon": "Lock",
                                            placeholder: "请输入登录密码",
                                            onKeydown: (0, vue_2.withKeys)(userLogin, ["enter"]),
                                            size: "large",
                                            type: "password",
                                            "show-password": "",
                                            modelValue: loginForm.password,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((loginForm.password) = $event); })
                                        }, null, 8, ["onKeydown", "modelValue"]),
                                        (0, vue_2.createElementVNode)("p", _hoisted_4, [
                                            (0, vue_2.createVNode)(_component_el_button, {
                                                type: "primary",
                                                link: "",
                                                onClick: _cache[3] || (_cache[3] = function ($event) { return ((0, vue_2.isRef)(isShowPswDialog) //@ts-ignore
                                                    ? isShowPswDialog.value = true : isShowPswDialog = true); })
                                            }, {
                                                default: (0, vue_2.withCtx)(function () { return [
                                                    (0, vue_2.createTextVNode)(" 忘记密码 ")
                                                ]; }),
                                                _: 1
                                            })
                                        ])
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, null, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_input, {
                                            size: "large",
                                            placeholder: "验证码区分大小写",
                                            onKeydown: (0, vue_2.withKeys)(userLogin, ["enter"]),
                                            modelValue: loginForm.verification,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((loginForm.verification) = $event); }),
                                            style: { "width": "51%" }
                                        }, null, 8, ["onKeydown", "modelValue"]),
                                        (0, vue_2.createElementVNode)("img", {
                                            class: "verification-code",
                                            src: (0, vue_2.unref)(verificationCode),
                                            alt: "验证码",
                                            onClick: fetchVerificationCode
                                        }, null, 8, _hoisted_5)
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_form_item, { style: { "padding-top": "30px" } }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            size: "large",
                                            style: { "width": "66%" },
                                            onClick: userLogin,
                                            type: "primary"
                                        }, {
                                            default: (0, vue_2.withCtx)(function () { return [
                                                (0, vue_2.createTextVNode)("登 录")
                                            ]; }),
                                            _: 1
                                        }),
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            size: "large",
                                            style: { "width": "30%" },
                                            onClick: _cache[5] || (_cache[5] = function ($event) { return ((0, vue_2.isRef)(isShowDialog) //@ts-ignore
                                                ? isShowDialog.value = true : isShowDialog = true); }),
                                            type: "success",
                                            plain: ""
                                        }, {
                                            default: (0, vue_2.withCtx)(function () { return [
                                                (0, vue_2.createTextVNode)("注 册")
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            _: 1
                        }, 8, ["model"])
                    ], 4),
                    (0, vue_2.createVNode)(_component_el_dialog, {
                        top: "3%",
                        modelValue: (0, vue_2.unref)(isShowDialog),
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) { return ((0, vue_2.isRef)(isShowDialog) ? (isShowDialog).value = $event : isShowDialog = $event); }),
                        title: "用户注册",
                        width: "50%"
                    }, {
                        footer: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createElementVNode)("span", _hoisted_6, [
                                (0, vue_2.createVNode)(_component_el_button, {
                                    size: "large",
                                    onClick: _cache[13] || (_cache[13] = function ($event) { return ((0, vue_2.isRef)(isShowDialog) //@ts-ignore
                                        ? isShowDialog.value = false : isShowDialog = false); })
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createTextVNode)("退 出")
                                    ]; }),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_el_button, {
                                    size: "large",
                                    type: "primary",
                                    onClick: _cache[14] || (_cache[14] = function ($event) { return (onFinish(ruleFormRef.value)); })
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createTextVNode)(" 提 交 ")
                                    ]; }),
                                    _: 1
                                })
                            ])
                        ]; }),
                        default: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createVNode)(_component_el_form, {
                                model: userForm,
                                rules: rules,
                                ref_key: "ruleFormRef",
                                ref: ruleFormRef,
                                class: "demo-ruleForm",
                                "label-width": "120px"
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createVNode)(_component_el_form_item, {
                                        prop: "user_account",
                                        label: "账号："
                                    }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                size: "large",
                                                modelValue: userForm.user_account,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((userForm.user_account) = $event); }),
                                                autocomplete: "off"
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, {
                                        prop: "user_name",
                                        label: "用户名："
                                    }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                size: "large",
                                                modelValue: userForm.user_name,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((userForm.user_name) = $event); }),
                                                autocomplete: "off"
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, {
                                        prop: "password",
                                        label: "密码："
                                    }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                size: "large",
                                                modelValue: userForm.password,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return ((userForm.password) = $event); }),
                                                autocomplete: "off",
                                                "show-password": "",
                                                type: "password"
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, {
                                        label: "电话：",
                                        prop: "tel"
                                    }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                size: "large",
                                                modelValue: userForm.tel,
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return ((userForm.tel) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, {
                                        label: "邮箱：",
                                        prop: "email"
                                    }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                size: "large",
                                                modelValue: userForm.email,
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) { return ((userForm.email) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, {
                                        label: "年龄：",
                                        prop: "age"
                                    }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                size: "large",
                                                type: "number",
                                                modelValue: userForm.age,
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) { return ((userForm.age) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, {
                                        size: "large",
                                        label: "性别：",
                                        prop: "sex"
                                    }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_select, {
                                                modelValue: userForm.sex,
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) { return ((userForm.sex) = $event); })
                                            }, {
                                                default: (0, vue_2.withCtx)(function () { return [
                                                    (0, vue_2.createVNode)(_component_el_option, {
                                                        label: "男",
                                                        value: "男"
                                                    }),
                                                    (0, vue_2.createVNode)(_component_el_option, {
                                                        label: "女",
                                                        value: "女"
                                                    }),
                                                    (0, vue_2.createVNode)(_component_el_option, {
                                                        label: "保密",
                                                        value: "保密"
                                                    })
                                                ]; }),
                                                _: 1
                                            }, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    })
                                ]; }),
                                _: 1
                            }, 8, ["model", "rules"])
                        ]; }),
                        _: 1
                    }, 8, ["modelValue"]),
                    (0, vue_2.createVNode)(_component_el_dialog, {
                        top: "5%",
                        modelValue: (0, vue_2.unref)(isShowPswDialog),
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) { return ((0, vue_2.isRef)(isShowPswDialog) ? (isShowPswDialog).value = $event : isShowPswDialog = $event); }),
                        title: "密码重置",
                        width: "50%"
                    }, {
                        footer: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createElementVNode)("span", _hoisted_7, [
                                (0, vue_2.createVNode)(_component_el_button, {
                                    size: "large",
                                    type: "primary",
                                    onClick: _cache[20] || (_cache[20] = function ($event) { return (onFinishPsw((0, vue_2.unref)(ruleFormPswRef))); })
                                }, {
                                    default: (0, vue_2.withCtx)(function () { return [
                                        (0, vue_2.createTextVNode)(" 提 交 ")
                                    ]; }),
                                    _: 1
                                })
                            ])
                        ]; }),
                        default: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createVNode)(_component_el_form, {
                                model: userPswForm,
                                rules: pswRules,
                                ref_key: "ruleFormPswRef",
                                ref: ruleFormPswRef,
                                class: "demo-ruleForm",
                                "label-width": "120px"
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createVNode)(_component_el_form_item, {
                                        prop: "user_account",
                                        label: "账号："
                                    }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                size: "large",
                                                modelValue: userPswForm.user_account,
                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) { return ((userPswForm.user_account) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, {
                                        label: "电话：",
                                        prop: "tel"
                                    }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                size: "large",
                                                modelValue: userPswForm.tel,
                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) { return ((userPswForm.tel) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, {
                                        label: "邮箱：",
                                        prop: "email"
                                    }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                size: "large",
                                                modelValue: userPswForm.email,
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) { return ((userPswForm.email) = $event); })
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_form_item, {
                                        prop: "password",
                                        label: "新密码："
                                    }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_input, {
                                                size: "large",
                                                modelValue: userPswForm.password,
                                                "onUpdate:modelValue": _cache[19] || (_cache[19] = function ($event) { return ((userPswForm.password) = $event); }),
                                                "show-password": "",
                                                type: "password"
                                            }, null, 8, ["modelValue"])
                                        ]; }),
                                        _: 1
                                    })
                                ]; }),
                                _: 1
                            }, 8, ["model", "rules"])
                        ]; }),
                        _: 1
                    }, 8, ["modelValue"])
                ]),
                _hoisted_8
            ]));
        };
    }
});
